import React from "react";

interface Step {
  number: number;
  title: string;
  description: string;
}

const steps: Step[] = [
  {
    number: 1,
    title: "Enter Your Details",
    description:
      "Answer a few quick questions about your age, income, savings, and goals.",
  },
  {
    number: 2,
    title: "Get Your Projections",
    description:
      "See when you can retire, your projected income, and a readiness score — instantly.",
  },
  {
    number: 3,
    title: "Explore What-If Scenarios",
    description:
      "Compare strategies side-by-side. Adjust assumptions and watch results update in real time.",
  },
];

/**
 * HowItWorks — Three-step explanation of how RetireEZ works.
 * Replaces the testimonials section on the landing page with honest,
 * verifiable content instead of fabricated social proof.
 */
export const HowItWorks: React.FC = () => {
  return (
    <section
      className="how-it-works-section"
      id="how-it-works"
      aria-label="How it works"
    >
      <h3 className="how-it-works-heading">How It Works</h3>

      <div className="how-it-works-steps" id="how-it-works-steps" role="list">
        {steps.map((step) => (
          <div
            key={step.number}
            className="how-it-works-step"
            id={`how-it-works-step-${step.number}`}
            role="listitem"
          >
            <div className="how-it-works-step-number" aria-hidden="true">
              {step.number}
            </div>
            <h4 className="how-it-works-step-title">{step.title}</h4>
            <p className="how-it-works-step-description">{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
